export const ACTIONS = {
  VIEW: 'VIEW'
}

export const SUBJECTS = {
  FILTERS: 'Filters',
  HEALTH_SYSTEMS_FILTER: 'Health Systems Filter',
  HOSPITALS_FILTER: 'Hospitals Filter',
  USER_FILTER: 'User Filter',
  PORTFOLIO_FILTER: 'Portfolio Filter',
  CC_FILTER: 'CC Filter',
  LED_BY_FILTER: 'Led By Filter',
  HEALTH_SYSTEMS_FILTER_MULTISELECT: 'Health Systems Filter MultiSelect',
  HOSPITALS_FILTER_MULTISELECT: 'Hospitals Filter MultiSelect',
  PORTFOLIO_FILTER_MULTISELECT: 'Portfolio Filter MultiSelect',
  CC_FILTER_MULTISELECT: 'CC Filter MultiSelect',
  LED_BY_FILTER_MULTISELECT: 'Led By Filter MultiSelect',
  USER_FILTER_MULTISELECT: 'User Filter MultiSelect',
  HEALTH_SYSTEMS_PREDEFINED: 'Health Systems Predefined',
  EXPECTED_SAVINGS_MENU: 'Expected Savings Menu',
  MY_HEALTH_SYSTEM_LABEL: 'My Health System Label'
}
